import { Injectable, computed } from '@angular/core';
import { ICalGtmBaseEvent } from '@cal-analytics/gtm';
import { GtmPartnersService } from '../../../../services/gtm-partners.service';

@Injectable({
  providedIn: 'root'
})
export class GtmOtpWarningService extends GtmPartnersService {
  protected step_title = 'wrong details';
  protected step_number = 3.3;
  protected sub_process_type = 'NA';
  protected error_type = 'מזכירים שצריך למלא את הפרטים של כרטיס כאל או דיינרס שלך';

  override getBaseEvent(): ICalGtmBaseEvent {
    return this.baseEvent()?.['wrongDetailsPage'];
  }

  override baseEvent = computed(() => ({
    wrongDetailsPage: {
      ...this.baseEvent$$(),
      step_title: this.step_title,
      step_number: this.step_number,
      sub_process_type: this.sub_process_type
    }
  }));
}
